module.exports = __webpack_public_path__ + "img/HelloBar.9b7dd85b.png";